export { PieChartComponent } from './pie/pie-chart.component';
export { BarChartComponent } from './bar-chart/bar-chart.component';